import Vue from 'vue';
import Router from 'vue-router';
import { Message } from 'element-ui';
import Layout from '@/views/layout';
import Screen from '@/views/layout-screen';
import ParentView from '@/components/ParentView/index';

Vue.use(Router);

export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    // redirect: 'resources-business/resource',
    redirect: '/home-page',
  },
  {
    path: '/login',
    component: (resolve) => require(['@/views/login/login.vue'], resolve),
    hidden: true,
  },
  {
    path: '/home-page',
    component: (resolve) =>
        require(['@/views/home-page/index.vue'], resolve),
    hidden: true,
  },
  {
    path: '/login_loading',
    component: (resolve) =>
      require(['@/views/login/login_loading.vue'], resolve),
    hidden: true,
  },
  {
    path: '/screen',
    component: Screen,
    redirect: '/screen/simulation',
    hidden: true,
    children: [
      {
        name: 'simulation',
        path: 'simulation',
        hidden: false,
        component: () =>
          import('@/views/simulation-regulation/simulation-screen/index.vue'),

      },

    ],
  },
];

export const asyncRoutes = [
  // 现货市场
  {
    name: 'SpotMarket',
    path: '/spot-market',
    redirect: 'noRedirect',
    hidden: false,
    alwaysShow: true,
    component: Layout,
    meta: {
      title: '现货市场',
      icon: 'SpotMarket',
    },
    children: [
      {
        name: 'MarketDynamics',
        path: 'market-dynamics',
        redirect: 'MarketOverview',
        hidden: false,
        alwaysShow: false,
        component: () => import('@/views/spot-market/market-dynamics'),
        meta: {
          title: '行情动态',
          icon: '行情动态',
        },
        children: [
          {
            name: 'MarketOverview',
            path: 'market-overview',
            hidden: false,
            component: () =>
              import('@/views/spot-market/market-dynamics/market-overview'),
            meta: {
              title: '市场概览',
              icon: '市场概览',
            },
          },
          {
            name: 'SpotPrice',
            path: 'spot-price',
            hidden: false,
            component: () =>
              import('@/views/spot-market/market-dynamics/spot-price'),
            meta: {
              title: '现货价格',
              icon: '现货价格',
            },
          },
          {
            name: 'SpotSpread',
            path: 'spot-spread',
            hidden: false,
            component: () =>
              import('@/views/spot-market/market-dynamics/spot-spread'),
            meta: {
              title: '现货价差',
              icon: '现货价差',
            },
          },
        ],
      },
      {
        name: 'MarketForecast',
        path: 'market-forecast',
        redirect: 'noRedirect',
        hidden: false,
        alwaysShow: true,
        meta: {
          title: '市场预测',
          icon: '市场预测',
        },
        component: () => import('@/views/spot-market/market-forecast'),
        children: [
          {
            name: 'PriceForecast',
            path: 'price-forecast',
            hidden: false,
            component: () =>
              import('@/views/spot-market/market-forecast/price-forecast'),
            meta: {
              title: '价格预测',
              icon: '价格预测',
            },
          },
          {
            name: 'LoadForecast',
            path: 'load-forecast',
            hidden: false,
            component: () =>
              import('@/views/spot-market/market-forecast/load-forecast'),
            meta: {
              title: '负荷预测',
              icon: '负荷预测',
            },
          },
          {
            name: 'ElectricityForecast',
            path: 'electricity-forecast',
            hidden: false,
            component: () =>
              import('@/views/spot-market/market-forecast/electricity-forecast'),
            meta: {
              title: '电量预测',
              icon: '电量预测',
            },
          },
          {
            name: 'SupplyDemandForecast',
            path: 'supply-demand-forecast',
            hidden: false,
            component: () =>
              import(
                '@/views/spot-market/market-forecast/supply-demand-forecast'
              ),
            meta: {
              title: '供需预测',
              icon: '供需预测',
            },
          },
          //
          {
            name: 'WeatherForecast',
            path: 'weather-forecast',
            hidden: false,
            component: () =>
              import('@/views/spot-market/market-forecast/weather-forecast'),
            meta: {
              title: '天气预报',
              icon: '天气预报',
            },
          },
        ],
      },
      {
        name: 'DataImport',
        path: 'data-import',
        hidden: false,
        component: () => import('@/views/spot-market/data-import'),
        meta: {
          title: '数据导入',
          icon: '数据导入',
        },
      },
      {
        name: 'MeasuringTool',
        path: '/measuring-tool',
        redirect: 'noRedirect',
        hidden: false,
        alwaysShow: true,
        meta: {
          title: '测算工具',
          icon: '测算工具',
        },
        children: [
          {
            name: 'GreenDistribution',
            path: 'green-distribution',
            hidden: false,
            component: () =>
              import('@/views/spot-market/measuring-tool/green-distribution'),
            meta: {
              title: '绿电分配计算',
              icon: '',
            },
          },
          {
            name: 'ElectricityEstimation',
            path: 'electricity-estimation',
            redirect: 'ElectricCalculation',
            hidden: false,
            alwaysShow: true,
            meta: {
              title: '中长期电量测算',
              icon: '',
            },
            component: () =>
              import(
                '@/views/spot-market/measuring-tool/electricity-estimation'
              ),
            children: [
              {
                name: 'ElectricCalculation',
                path: 'electric-calculation',
                hidden: false,
                component: () =>
                  import(
                    '@/views/spot-market/measuring-tool/electricity-estimation/electric-calculation'
                  ),
                meta: {
                  title: '电量测算',
                  icon: '',
                },
              },

              {
                name: 'ContractImport',
                path: 'contract-import',
                hidden: false,
                component: () => import('@/views/spot-market/measuring-tool/electricity-estimation/contract-import'),
                meta: {
                  title: '测算合同导入',
                  icon: '',
                },
              },

            ]
          },
        ],
      },
    ],
  },
  // 运营看板
  {
    name: 'resourcesBusiness',
    path: '/resources-business',
    redirect: 'noRedirect',
    hidden: false,
    alwaysShow: true,
    component: Layout,
    meta: {
      title: '运营看板',
      icon: 'resourcesBusiness',
    },
    children: [
      {
        name: 'resource',
        path: 'resource',
        hidden: false,
        component: () => import('@/views/resources-business/resources/index'),
        meta: {
          title: '资源总览',
          icon: ' ',
        },
      },
      {
        name: 'resourceCZ',
        path: 'resource-changzhou',
        hidden: false,
        component: () =>
          import('@/views/resources-business/resources-changzhou'),
        meta: {
          title: '资源总览CZ',
          icon: ' ',
        },
      },
      {
        name: 'business',
        path: 'business',
        hidden: false,
        component: () => import('@/views/resources-business/business'),
        meta: {
          title: '业务概况',
          icon: ' ',
        },
      },
    ],
  },
  // 量测模型
  {
    name: 'MeasureModel',
    path: '/measure-model',
    redirect: 'noRedirect',
    hidden: false,
    alwaysShow: true,
    component: Layout,
    meta: {
      title: '量测模型',
      icon: 'MeasureModel',
    },
    children: [
      {
        name: 'MeasureManage',
        path: 'measure-manage',
        hidden: false,
        component: () => import('@/views/measure-model/measure-manage'),
        meta: {
          title: '测点管理',
          icon: ' ',
        },
      },
      {
        name: 'DeviceTemplate',
        path: 'device-template',
        hidden: false,
        component: () => import('@/views/measure-model/device-template'),
        meta: {
          title: '设备模板',
          icon: ' ',
        },
      },
    ],
  },

  // 档案管理
  {
    name: 'FileMmanagement',
    path: '/file-management',
    redirect: 'noRedirect',
    hidden: false,
    alwaysShow: true,
    component: Layout,
    meta: {
      title: '档案管理',
      icon: 'FileMmanagement',
    },
    children: [
      {
        name: 'EnterpriseFile',
        path: 'enterprise-file',
        hidden: false,
        component: () => import('@/views/file-management/enterprise-file'),
        meta: {
          title: '企业档案',
          icon: ' ',
        },
      },
      {
        name: 'EnterpriseFileCZ',
        path: 'enterprise-file-changzhou',
        hidden: false,
        component: () =>
          import('@/views/file-management/enterprise-file-changzhou'),
        meta: {
          title: '企业档案-cz',
          icon: ' ',
        },
      },
      {
        name: 'EquipmentFile',
        path: 'equipment-file',
        hidden: false,
        component: () => import('@/views/file-management/equipment-file'),
        meta: {
          title: '设备档案',
          icon: ' ',
        },
      },
      {
        name: 'EquipmentFileCZ',
        path: 'equipment-file-changzhou',
        hidden: false,
        component: () =>
          import('@/views/file-management/equipment-file-changzhou'),
        meta: {
          title: '设备档案-cz',
          icon: ' ',
        },
      },
      // {
      //   name: 'quotientFile',
      //   path: 'quotient-file',
      //   hidden: false,
      //   component: () => import('@/views/file-management/quotient-file'),
      //   meta: {
      //     title: '聚合商档案',
      //     icon: ' ',
      //   },
      // },
    ],
  },
  // 负荷监测
  {
    name: 'loadMonitor',
    path: '/load-monitor',
    redirect: 'noRedirect',
    hidden: false,
    alwaysShow: true,
    component: Layout,
    meta: {
      title: '负荷监测',
      icon: 'loadMonitor',
    },
    children: [
      {
        name: 'cityMonitor',
        path: 'city-monitor',
        hidden: false,
        component: () => import('@/views/load-monitor/city-monitor'),
        meta: {
          title: '地市监测',
          icon: ' ',
        },
      },
      {
        name: 'cityMonitorCZ',
        path: 'city-monitor-changzhou',
        hidden: false,
        component: () => import('@/views/load-monitor/city-monitor-changzhou'),
        meta: {
          title: '地市监测-cz',
          icon: ' ',
        },
      },
      {
        name: 'industryMonitor',
        path: 'industry-monitor',
        hidden: false,
        component: () => import('@/views/load-monitor/industry-monitor'),
        meta: {
          title: '行业监测',
          icon: ' ',
        },
      },

      {
        name: 'HistoryMonitor',
        path: 'history-monitor',
        hidden: false,
        component: () => import('@/views/load-monitor/history-monitor'),
        meta: {
          title: '用户监测',
          icon: ' ',
        },
      },
      {
        name: 'HistoryMonitorCZ',
        path: 'history-monitor-changzhou',
        hidden: false,
        component: () =>
          import('@/views/load-monitor/history-monitor-changzhou'),
        meta: {
          title: '用户监测-cz',
          icon: ' ',
        },
      },
      // {
      //   name: 'userMonitor',
      //   path: 'user-monitor',
      //   hidden: false,
      //   component: () => import('@/views/load-monitor/user-monitor'),
      //   meta: {
      //     title: '设备监测',
      //     icon: ' ',
      //   },
      // },
      {
        name: 'HistoryMonitorEdit',
        path: 'history-monitor-deviceNum',
        hidden: true,
        component: () =>
          import('@/views/load-monitor/history-monitor/deviceNum.vue'),
        meta: {
          title: '历史负荷-设备数量',
          icon: ' ',
        },
      },
    ],
  },
  // 需求响应
  {
    name: 'demandResponse',
    path: '/demand-response',
    redirect: 'noRedirect',
    hidden: false,
    alwaysShow: true,
    component: Layout,
    meta: {
      title: '需求响应',
      icon: 'demandResponse',
    },
    children: [
      {
        name: 'userProfile',
        path: 'user-profile',
        hidden: false,
        component: () => import('@/views/demand-response/user-profile'),
        meta: {
          title: '用户档案',
          icon: ' ',
        },
      },
      {
        name: 'contractFile',
        path: 'contract-file',
        hidden: false,
        component: () => import('@/views/demand-response/contract-archives'),
        meta: {
          title: '合同档案',
          icon: ' ',
        },
      },

      {
        name: 'eventInitiation',
        path: 'event-initiation',
        hidden: false,
        component: () => import('@/views/demand-response/event-initiation'),
        meta: {
          title: '事件启动',
          icon: ' ',
        },
      },
      {
        name: 'eventCalendar',
        path: 'event-calendar',
        hidden: false,
        component: () => import('@/views/demand-response/event-calendar'),
        meta: {
          title: '事件日历',
          icon: ' ',
        },
      },
      {
        name: 'eventCalendarEdit',
        path: 'event-calendar-edit',
        hidden: true,
        component: () =>
          import('@/views/demand-response/event-calendar/edit.vue'),
        meta: {
          title: '事件日历编辑',
          icon: ' ',
        },
      },
      {
        name: 'settleManagement',
        path: 'settle-management',
        hidden: false,
        component: () => import('@/views/demand-response/settle-management'),
        meta: {
          title: '结算管理',
          icon: ' ',
        },
      },
    ],
  },
  // 辅助服务
  {
    name: 'ancillaryServices',
    path: '/ancillary-services',
    redirect: 'noRedirect',
    hidden: false,
    alwaysShow: true,
    component: Layout,
    meta: {
      title: '辅助服务',
      icon: 'ancillaryServices',
    },
    children: [
      {
        name: 'customerProfile',
        path: 'customer-profile',
        hidden: false,
        component: () => import('@/views/ancillary-services/customer-profile'),
        meta: {
          title: '客户档案',
          icon: ' ',
        },
      },
      {
        name: 'contractFile2',
        path: 'contract-file',
        hidden: false,
        component: () => import('@/views/ancillary-services/contract-file'),
        meta: {
          title: '合同档案',
          icon: ' ',
        },
      },
      {
        name: 'loadCurve',
        path: 'load-curve',
        hidden: false,
        component: () => import('@/views/ancillary-services/load-curve'),
        meta: {
          title: '负荷预测',
          icon: ' ',
        },
      },
      {
        name: 'configForecast2',
        path: 'load-curve/config-forecast',
        hidden: false,
        component: () =>
          import('@/views/ancillary-services/load-curve/config-forecast'),
        meta: {
          title: '预测配置',
          icon: ' ',
        },
      },
      {
        name: 'demandCalendar',
        path: 'demand-calendar',
        hidden: false,
        component: () => import('@/views/ancillary-services/demand-calendar'),
        meta: {
          title: '需求日历',
          icon: ' ',
        },
      },

      {
        name: 'participationDetails',
        path: 'participation-details',
        hidden: true,
        component: () =>
          import(
            '@/views/ancillary-services/demand-calendar/participation-details'
          ),
        meta: {
          title: '需求日历-参与用户详情',
          icon: ' ',
        },
      },
      {
        name: 'demandInitiation',
        path: 'demand-initiation',
        hidden: true,
        component: () => import('@/views/ancillary-services/demand-initiation'),
        meta: {
          title: '用户邀约',
          icon: ' ',
        },
      },
      {
        name: 'transactionDeclaration',
        path: 'transaction-declaration',
        hidden: false,
        component: () =>
          import('@/views/ancillary-services/transaction-declaration'),
        meta: {
          title: '交易申报',
          icon: ' ',
        },
      },
      {
        name: 'eventCalendar',
        path: 'event-calendar',
        hidden: false,
        component: () => import('@/views/ancillary-services/event-calendar'),
        meta: {
          title: '时间日历',
          icon: ' ',
        },
      },
      {
        name: 'settlementManagement',
        path: 'settlement-management',
        hidden: false,
        component: () =>
          import('@/views/ancillary-services/settlement-management'),
        meta: {
          title: '结算管理',
          icon: ' ',
        },
      },
    ],
  },

  // 负荷预测
  {
    name: 'loadForecast',
    path: '/load-forecast',
    redirect: 'noRedirect',
    hidden: false,
    alwaysShow: true,
    component: Layout,
    meta: {
      title: '负荷预测',
      icon: 'loadForecast',
    },
    children: [
      {
        name: 'userForecast',
        path: 'user-forecast',
        hidden: false,
        component: () => import('@/views/load-forecast/user-forecast'),
        meta: {
          title: '用户预测',
          icon: ' ',
        },
      },
      {
        name: 'configForecast',
        path: 'config-forecast',
        hidden: false,
        component: () => import('@/views/load-forecast/config-forecast'),
        meta: {
          title: '预测配置',
          icon: ' ',
        },
      },
      {
        name: 'logForecast',
        path: 'log-forecast',
        hidden: false,
        component: () => import('@/views/load-forecast/log-forecast'),
        meta: {
          title: '预测日志',
          icon: ' ',
        },
      },
    ],
  },
  // 单体控制
  {
    name: 'singleControl',
    path: '/single-control',
    redirect: 'noRedirect',
    hidden: false,
    alwaysShow: true,
    component: Layout,
    meta: {
      title: '单体控制',
      icon: 'singleControl',
    },
    children: [
      {
        name: 'airConditioningControl',
        path: 'airConditioning-control',
        hidden: false,
        component: () => import('@/views/remote-control/single-control'),
        meta: {
          title: '空调控制',
          icon: ' ',
        },
      },
      {
        name: 'airConditioningControlEdit',
        path: 'airConditioning-control-edit',
        hidden: true,
        component: () =>
          import('@/views/remote-control/single-control/edit.vue'),
        meta: {
          title: '空调控制编辑',
          icon: ' ',
        },
      },
    ],
  },
  // 远程控制
  {
    name: 'remoteControl',
    path: '/remote-control',
    redirect: 'noRedirect',
    hidden: false,
    alwaysShow: true,
    component: Layout,
    meta: {
      title: '远程控制',
      icon: 'remoteControl',
    },
    children: [
      // {
      //   name: 'singleControl',
      //   path: 'single-control',
      //   hidden: false,
      //   component: () => import('@/views/remote-control/single-control'),
      //   meta: {
      //     title: '单体控制',
      //     icon: ' ',
      //   },
      // },
      // {
      //   name: 'singleControlEdit',
      //   path: 'single-control-edit',
      //   hidden: true,
      //   component: () =>
      //     import('@/views/remote-control/single-control/edit.vue'),
      //   meta: {
      //     title: '空调控制编辑',
      //     icon: ' ',
      //   },
      // },
      {
        name: 'controllableResources',
        path: 'controllable-resources',
        hidden: false,
        component: () =>
          import('@/views/remote-control/controllable-resources'),
        meta: {
          title: '资源管理',
          icon: ' ',
        },
      },
      {
        name: 'demandDecomposition',
        path: 'demand-decomposition',
        hidden: false,
        component: () => import('@/views/remote-control/demand-decomposition'),
        meta: {
          title: '需求分解',
          icon: ' ',
        },
      },

      {
        name: 'groupControl',
        path: 'group-control',
        hidden: false,
        component: () => import('@/views/remote-control/group-control'),
        meta: {
          title: '群组管理',
          icon: ' ',
        },
      },
      {
        name: 'groupIssued',
        path: 'group-issued',
        hidden: false,
        component: () => import('@/views/remote-control/group-issued'),
        meta: {
          title: '群控下发',
          icon: ' ',
        },
      },
      {
        name: 'groupEvent',
        path: 'group-event',
        hidden: false,
        component: () => import('@/views/remote-control/group-event'),
        meta: {
          title: '群控事件',
          icon: ' ',
        },
      },
      {
        name: 'groupEventDetail',
        path: 'group-event-detail',
        hidden: true,
        component: () =>
          import('@/views/remote-control/group-event/detail.vue'),
        meta: {
          title: '群控事件详情',
          icon: ' ',
        },
      },
    ],
  },
  // 上送管理
  {
    name: 'uploadManagement',
    path: '/upload-management',
    redirect: 'noRedirect',
    hidden: false,
    alwaysShow: true,
    component: Layout,
    meta: {
      title: '上送管理',
      icon: 'uploadManagement',
    },
    children: [
      {
        name: 'uploadUser',
        path: 'upload-user',
        hidden: false,
        component: () => import('@/views/upload-management/upload-user'),
        meta: {
          title: '用户管理',
          icon: ' ',
        },
      },
      {
        name: 'uploadDevice',
        path: 'upload-device',
        hidden: false,
        component: () => import('@/views/upload-management/upload-device'),
        meta: {
          title: '设备管理',
          icon: ' ',
        },
      },
      {
        name: 'cpsMonitor',
        path: 'cps-monitor',
        hidden: false,
        component: () => import('@/views/upload-management/cps-monitor'),
        meta: {
          title: '数据监测',
          icon: ' ',
        },
      },
    ],
  },
  // 资产管理
  {
    name: 'assetManagement',
    path: '/asset-management',
    redirect: 'noRedirect',
    hidden: false,
    alwaysShow: true,
    component: Layout,
    meta: {
      title: '资产管理',
      icon: 'assetManagement',
    },
    children: [
      {
        name: 'projectManagement',
        path: 'project-management',
        hidden: false,
        component: () => import('@/views/asset-management/project-management'),
        meta: {
          title: '项目管理',
          icon: ' ',
        },
      },
      {
        name: 'userManagement',
        path: 'user-management',
        hidden: false,
        component: () => import('@/views/asset-management/user-management'),
        meta: {
          title: '用户管理',
          icon: ' ',
        },
      },
      {
        name: 'equipmentManagement',
        path: 'equipment-management',
        hidden: false,
        component: () =>
          import('@/views/asset-management/equipment-management'),
        meta: {
          title: '设备管理',
          icon: ' ',
        },
      },
    ],
  },
  // 系统配置
  {
    name: 'systemConfig',
    path: '/system-config',
    redirect: 'noRedirect',
    hidden: false,
    alwaysShow: true,
    component: Layout,
    meta: {
      title: '系统配置',
      icon: 'systemConfig',
    },
    children: [
      {
        name: 'uploadOperators',
        path: 'upload-operators',
        hidden: false,
        component: () => import('@/views/upload-management/upload-operators'),
        meta: {
          title: '运营商管理',
          icon: ' ',
        },
      },
      // {
      //   name: 'MQTTManagement',
      //   path: 'MQTT-management',
      //   hidden: false,
      //   component: () => import('@/views/system-config/MQTT-management'),
      //   meta: {
      //     title: 'MQTT管理',
      //     icon: ' ',
      //   },
      // },
      {
        name: 'dictionaryManagement',
        path: 'dictionary-management',
        hidden: false,
        component: () => import('@/views/system-config/dictionary-management'),
        meta: {
          title: '字典管理',
          icon: ' ',
        },
      },
      {
        name: 'offlineList',
        path: 'offline-list',
        hidden: false,
        component: () => import('@/views/event-record/offline-list'),
        meta: {
          title: '离线清单',
          icon: ' ',
        },
      },
      {
        name: 'UserConfig',
        path: 'user-config',
        hidden: false,
        component: () => import('@/views/permission-config/user-config'),
        meta: {
          title: '用户管理',
          icon: ' ',
        },
      },
      {
        name: 'RoleConfig',
        path: 'role-config',
        hidden: false,
        component: () => import('@/views/permission-config/role-config'),
        meta: {
          title: '角色管理',
          icon: ' ',
        },
      },
      {
        name: 'RouterConfig',
        path: 'router-config',
        hidden: false,
        component: () => import('@/views/permission-config/router-config'),
        meta: {
          title: '路由管理',
          icon: ' ',
        },
      },
      {
        name: 'ResourceConfig',
        path: 'resource-config',
        hidden: false,
        component: () => import('@/views/permission-config/resource-config'),
        meta: {
          title: '资源管理',
          icon: ' ',
        },
      },
      {
        name: 'userLoad',
        path: 'user-load',
        hidden: false,
        component: () => import('@/views/permission-config/user-load'),
        meta: {
          title: '用户负荷',
          icon: ' ',
        },
      },
    ],
  },
  // 日志记录
  // {
  //   name: 'eventRecord',
  //   path: '/event-record',
  //   redirect: 'noRedirect',
  //   hidden: true,
  //   alwaysShow: true,
  //   component: Layout,
  //   meta: {
  //     title: '日志记录',
  //     icon: 'eventRecord',
  //   },
  //   children: [
  //     {
  //       name: 'offlineList',
  //       path: 'offline-list',
  //       hidden: false,
  //       component: () => import('@/views/event-record/offline-list'),
  //       meta: {
  //         title: '离线清单',
  //         icon: ' ',
  //       },
  //     },
  //   ],
  // },
  // 权限管理
  // {
  //   name: 'permissionConfig',
  //   path: '/permission-config',
  //   redirect: 'noRedirect',
  //   hidden: true,
  //   alwaysShow: true,
  //   component: Layout,
  //   meta: {
  //     title: '权限管理',
  //     icon: 'permissionConfig',
  //   },
  //   children: [
  //     {
  //       name: 'UserConfig',
  //       path: 'user-config',
  //       hidden: false,
  //       component: () => import('@/views/permission-config/user-config'),
  //       meta: {
  //         title: '用户管理',
  //         icon: ' ',
  //       },
  //     },
  //     {
  //       name: 'RoleConfig',
  //       path: 'role-config',
  //       hidden: false,
  //       component: () => import('@/views/permission-config/role-config'),
  //       meta: {
  //         title: '角色管理',
  //         icon: ' ',
  //       },
  //     },
  //     {
  //       name: 'RouterConfig',
  //       path: 'router-config',
  //       hidden: false,
  //       component: () => import('@/views/permission-config/router-config'),
  //       meta: {
  //         title: '路由管理',
  //         icon: ' ',
  //       },
  //     },
  //     {
  //       name: 'ResourceConfig',
  //       path: 'resource-config',
  //       hidden: false,
  //       component: () => import('@/views/permission-config/resource-config'),
  //       meta: {
  //         title: '资源管理',
  //         icon: ' ',
  //       },
  //     },
  //   ],
  // },
];

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    // 实例化vue的时候只挂载constantRoutes
    routes: constantRoutes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
